import { Injectable } from '@angular/core';

/**
 * Service providing label mappings for powder coating system attributes.
 * Based on QUALICOAT Vol. 3 Specifications (2025-03-31)
 */
@Injectable({ providedIn: 'root' })
export class PowderLabelService {
  // Class labels based on Florida outdoor exposure test duration
  readonly classLabels: Record<number, string> = {
    1: 'Class 1 (1 year Florida)',
    1.5: 'Class 1.5 (2 years Florida)',
    2: 'Class 2 (3 years Florida)',
    3: 'Class 3 (10 years Florida)',
  };

  // Gloss category labels based on gloss units at 60 degrees
  readonly glossCategoryLabels: Record<number, string> = {
    1: 'Matt (0-30 gloss units)',
    2: 'Satin (31-70 gloss units)',
    3: 'Gloss (71-100 gloss units)',
  };

  // Structure finish labels
  readonly structureFinishLabels: Record<string, string> = {
    L: 'Leathered',
    T: 'Textured',
    W: 'Wrinkled',
    N: 'No Structure Finish',
  };

  // Approval type labels
  readonly approvalTypeLabels: Record<number, string> = {
    1: 'Standard Approval',
    2: 'Metallic-Only Approval',
    3: 'Single Colour Approval'
  };

  // Coating material labels (1=Powder, 2=Liquid, 3=Two coat)
  readonly coatingMaterialLabels: Record<number, string> = {
    1: 'Powder Coating',
    2: 'Liquid Coating',
    3: 'Two-Coat Organic Coatings',
  };

  // 0 is the backend default for unset numeric attributes, so it counts as unset here.
  getClassLabel(value: number | null | undefined): string {
    if (!value) return '-';
    return this.classLabels[value] ?? `Class ${value}`;
  }

  getGlossCategoryLabel(value: number | null | undefined): string {
    if (!value) return '-';
    return this.glossCategoryLabels[value] ?? `Category ${value}`;
  }

  getStructureFinishLabel(value: string | null | undefined): string {
    if (!value) return '-';
    return this.structureFinishLabels[value] ?? value;
  }

  getApprovalTypeLabel(value: number | null | undefined): string {
    if (!value) return '-';
    return this.approvalTypeLabels[value] ?? `Type ${value}`;
  }

  getCoatingMaterialLabel(value: number | null | undefined): string {
    if (!value) return '-';
    return this.coatingMaterialLabels[value] ?? `Material ${value}`;
  }
}
